import Composto from './Composto'

export default class CandidatoCurso {
  constructor() {
    this.id = 0;
    this.candidato_id = new Composto();
    this.tp_formacao = new Composto();
    this.tp_concluso = new Composto();
    this.tp_area = new Composto();
    this.nome = "";
    this.carga_horaria = "";
    this.curso = "";
    this.detalhes = "";
  }
}
